import { makeStyles } from "@material-ui/core/styles"
import React from "react"
import logoImage from "./img/MyPardini-Icon.png"
import { configureEnvironment } from './../../../config/env';
import { formatarUrlComSessionId } from '../../../shared/utils/Formatacao'

const Logo = ({ id }) => {
	const classes = useStyles()
	const urlMyPardini = formatarUrlComSessionId(configureEnvironment().REACT_APP_URL_PAGINA_INICIAL_MY_PARDINI);

	return (
		<div className={classes.container}>
			<a href={urlMyPardini} className={classes.link}>
				<img src={logoImage} className={classes.logo} alt="Logo" id={id} />
			</a>
		</div>
	)
}

const useStyles = makeStyles({
	container: {
		width: "80px",
		paddingBottom: "20px",
		paddingTop: "10px",
		textAlign: "center"
	},
	logo: {
		height: "65px",
		width: "65px",
	},
})

export default Logo